
// Define the status options for referrals
export enum ReferralStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired'
}

// Define the Referral interface
export interface Referral {
  id: string;
  referrerId: string;
  referrerName: string;
  referrerEmail: string;
  refereeId: string;
  refereeName: string;
  refereeEmail: string;
  status: ReferralStatus;
  points: number;
  createdAt: string;
  convertedAt?: string;
  // These fields are used in some implementations
  name?: string;
  email?: string;
  date?: string;
}

// Define the ReferralTemplate interface
export interface ReferralTemplate {
  id: string;
  name: string;
  subject: string;
  body: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
  type: 'email' | 'sms' | 'social';
  variables: string[];
}

// Define interfaces for tracking referral clicks
export interface ReferralClick {
  id: string;
  referralCode: string;
  referrerId: string;
  clickedAt: string;
  ipAddress?: string;
  userAgent?: string;
  source?: string;
  medium?: string;
  campaign?: string;
  convertedAt?: string;
  converted: boolean;
  // Add missing properties used in ReferralLinkTrackingReport
  origin?: string;
  landingPage?: string;
  timestamp?: string;
  visitorInfo?: {
    name?: string;
    email?: string;
    converted?: boolean;
    signupDate?: string;
  };
  clickDate?: string;
}

// Define interface for click statistics
export interface ClickStatistics {
  totalClicks: number;
  uniqueClicks: number;
  conversionRate: number;
  sourceBreakdown: Record<string, number>;
  timeDistribution: Record<string, number>;
}

// Define interface for notification preferences
export interface NotificationPreference {
  userId: string;
  type: 'email' | 'sms' | 'push' | 'in-app';
  enabled: boolean;
  frequency: 'instant' | 'daily' | 'weekly' | 'monthly' | 'never';
  updatedAt: string;
  id?: string;
}

// Define interface for notification templates
export interface NotificationTemplate {
  id: string;
  name: string;
  type: 'email' | 'sms' | 'push';
  subject?: string;
  body: string;
  content?: string; // Add missing content property used in NotificationTemplatesForm
  template?: string; // For backward compatibility
  variables: string[];
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

// Add missing type for NotificationPreferences
export interface NotificationPreferences {
  referral: {
    onSignup: boolean;
    onPurchase: boolean;
    onStatusChange: boolean;
  };
  rewards: {
    onEarned: boolean;
    onRedeemed: boolean;
    onExpiring: boolean;
  };
  marketing: {
    promotions: boolean;
    announcements: boolean;
    newsletter: boolean;
  };
  channels: {
    email: boolean;
    sms: boolean;
    push: boolean;
  };
}
